export default __webpack_public_path__ + "static/media/colecao.c155adbd.webp";